import FaceActivateModal from './ActivationFace';

export default FaceActivateModal;
